import React from 'react';

export enum SearchApp {
	CHANGE_LOG = 'CHANGE_LOG',
	BENEFIT_GROUP_CHANGE_LOG = 'BENEFIT_GROUP_CHANGE_LOG',
	NONE = 'NONE',
}

export const SearchAppContext = React.createContext(SearchApp.NONE);

export interface FilterOption {
	key: string,
	display: string,
	value: string,
}

export enum SortBy {
	DESCENDING = 'desc',
	ASCENDING = 'asc',
}

export interface SortFilter {
	type: string,
	sortBy: SortBy,
}
export interface FilterOptions {
	type: string,
	options: FilterOption[],
}

export interface Filter {
	type: string,
	value: string,
	display?: string,
}

export interface FilterPill {
	type: string,
	label: string,
	value: string,
	rawValue: string,
	display?: string,
}

export interface BackendSearchState {
	seletedFilters: Filter[],
	filterPills: FilterPill[],
	filterOptions: { [key: string]: FilterOptions },
	requesting: boolean,
	list: any[],
	sorts: SortFilter[],
	currentPage: number,
	totalPage: number,
	totalCount: number,
	pageSize: number,
}

export interface BackendSearchStates {
	[SearchApp.CHANGE_LOG]: BackendSearchState,
	[SearchApp.BENEFIT_GROUP_CHANGE_LOG]: BackendSearchState,
}

export enum BackendSearchActions {
	SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS',
	ADD_FILTER = 'ADD_FILTER',
	REMOVE_FILTER = 'REMOVE_FILTER',
	SET_LIST = 'SET_LIST',
	BEGIN_REQUEST = 'BEGIN_REQUEST',
	SET_FILTER_PILLS = 'SET_FILTER_PILLS',
	RESET_SEARCH = 'RESET_SEARCH',
	UPDATE_SORT_FILTER = 'UPDATE_SORT_FILTER',
	SET_PAGINATION_INFO = 'SET_PAGINATION_INFO',
	UPDATE_PAGE = 'UPDATE_PAGE',
	END_REQUEST = 'END_REQUEST',

}


export enum FilterTypes {
	from = 'from_date',
	to = 'to_date',
	employee = 'employee',
	submittedBy = 'submitted_by',
	eventType = 'event_type',
	submittedDate = 'submitted_date',
	effectiveDate = 'effective_date',
	lastActivityDate = 'lastActivityDate',
	status = 'status',
	requestBy = 'requestBy',
	completed = 'completed',
	changeMadeFor = 'changeMadeFor',
	changeType = 'changeType',
	dateType = 'dateType',
}